<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { fetchTraceLog } from "../services/apiClient.ts";

const route = useRoute();
const router = useRouter();

const traceContent = ref<string | undefined>(undefined);
const error = ref<string | undefined>(undefined);
const loading = ref(true);

const blobId = Array.isArray(route.query.blobId)
  ? route.query.blobId[0]
  : (route.query.blobId as string | undefined);

onMounted(async () => {
  if (!blobId) {
    error.value =
      "No trace log ID provided. Return to the results page and try again.";
    loading.value = false;
    return;
  }
  try {
    traceContent.value = await fetchTraceLog(blobId);
  } catch (error_) {
    error.value = error_ instanceof Error ? error_.message : String(error_);
  } finally {
    loading.value = false;
  }
});
</script>

<template>
  <main class="page-main-container overflow-y-auto">
    <div
      class="flex min-h-0 flex-1 flex-col rounded-lg bg-white shadow-[0_2px_8px_rgb(0_0_0/8%)]"
    >
      <div class="panel-card-header shrink-0">
        <h2>📋 Algorithm Trace Log</h2>
        <button
          class="panel-secondary-button"
          @click="router.push({ name: 'results' })"
        >
          ← Back to Results
        </button>
      </div>
      <div class="flex min-h-0 flex-1 flex-col px-6 py-6">
        <div v-if="loading" class="text-sm text-slate-500">
          Loading trace log…
        </div>
        <div v-else-if="error" class="status-banner-base status-banner-error">
          <span class="text-[20px]">❌</span>
          {{ error }}
        </div>
        <pre
          v-else
          class="min-h-0 flex-1 overflow-auto rounded border border-slate-200 bg-slate-50 p-4 font-mono text-xs leading-relaxed whitespace-pre-wrap text-slate-800"
          >{{ traceContent }}</pre
        >
      </div>
    </div>
  </main>
</template>
